import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar, Drawer, Sidebar } from 'flowbite-react';
import {
  HiHome,
  HiMicrophone,
} from 'react-icons/hi';
import { FaCalendarCheck } from "react-icons/fa6";
import { RiGraduationCapFill } from "react-icons/ri";
import { useAuth } from '../../context/AuthContext';
import './HeaderComponent.css';
import logsUserService from '../../services/LogsUserActionService';

const HeaderComponent = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { token, idUser, name, lastName, logout } = useAuth();

  const [isDropMobilOpen, setIsDropMobileOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const location = useLocation();
  const source = sessionStorage.getItem("source");

  const isActive = (path) => {
    // Verifica si la ruta actual comienza con el path proporcionado
    return location.pathname.startsWith(path) ? 'active' : '';
  }

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLinkClick = () => {
    setIsDropdownOpen(false);

    if (isOpen) {
      handleDrawerClick()
    }
  };

  const handleDrawerClick = () => {
    handleClose()
  }

  const toggleDropdownMobile = () => {
    setIsDropMobileOpen(!isDropMobilOpen);
  }

  const logoutObesity = () => {

    logout();

    setTimeout(() => {
      window.location.href = 'https://www.onenovonordisk.com/';
    }, 200);
  };

  const formatSpeakerName = (name) => {
    // Verifica si el nombre ya contiene "Dr."
    if (name.startsWith('Dr.')) {
      return name;
    }
    // Si no, agrega "Dr." al inicio
    return <span>Dr. <span className="ApisBold">{name}</span></span>;
  };

  return (
    <>
      <Navbar fluid rounded>
        <Navbar.Brand>
          <img
            src="/images/icons/nav-logo.png"
            width="140"
            height="80"
            className="d-inline-block align-text-top p-2 ml-2"
            alt="Logo"
          />
        </Navbar.Brand>
        <div className="flex md:order-2">
          <Navbar.Toggle className="button" onClick={handleOpen} />
        </div>
        <Navbar.Collapse className="ml-auto mr-5">
          <ul className='flex flex-col align-center items-center md:mt-0 md:flex-row md:space-x-8 md:text-sm md:font-medium'>
            {source == 'POEP' ?
              null
              :
              <Navbar.Link
                className="block py-2 pl-3 pr-4 md:p-0 Navbar-Link no-underline"
              >
                {/* <Link
                  to="/inicio"
                  onClick={() => { handleLinkClick(); logsUserService(idUser, "Clic en Inicio", token) }}
                  className={`nav-link ApisRegular text-items-nav ${isActive('/inicio')}`}
                  style={{ color: 'inherit' }}
                >
                  <HiHome className={`mr-1 inline ico ${isActive('/inicio') ? 'ico-active' : 'ico-normal'}`} />
                  Inicio
                </Link> */}
              </Navbar.Link>
            }

            {source == 'POEP' ?
              null
              :
              <Navbar.Link
                className="block py-2 pl-3 pr-4 md:p-0 Navbar-Link no-underline"
              >
                {/* <Link
                  to="/eventos"
                  onClick={() => { handleLinkClick(); logsUserService(idUser, "Clic en Eventos", token) }}
                  className={`nav-link ApisRegular text-items-nav ${isActive('/eventos')}`}
                  style={{ color: 'inherit' }}
                >
                  <FaCalendarCheck className={`mr-1 inline ico ${isActive('/eventos') ? 'ico-active' : 'ico-normal'}`} />
                  Eventos
                </Link> */}
              </Navbar.Link>
            }

            <Navbar.Link
              className="block py-2 pl-3 pr-4 md:p-0 Navbar-Link no-underline"
            >
              <Link
                to="/e-learning-hub"
                onClick={() => { handleLinkClick(); logsUserService(idUser, "Clic en E-Learning Hub", token) }}
                className={`nav-link ApisRegular text-items-nav ${isActive('/e-learning-hub')}`}
                style={{ color: 'inherit' }}
              >
                <RiGraduationCapFill className={`mr-1 inline ico ${isActive('/e-learning-hub') ? 'ico-active' : 'ico-normal'}`} />
                E-Learning Hub
              </Link>
            </Navbar.Link>
            {source == 'POEP' ?
              null
              :
              <></>
              // <Navbar.Link
              //   href="https://www.onenovonordisk.com/obesidad/podcast-mas-alla-del-peso.html"
              //   target='_blank'
              //   className="block ApisRegular nav-link py-2 pl-3 pr-4 md:p-0 text-dark-purple-200 no-underline hover:text-pink-500"
              // >
              //   <HiMicrophone className={`mr-1 inline ico-normal`} />
              //   Podcast
              // </Navbar.Link>
            }
          </ul>
          {/* <Navbar.Link
            href="https://outlook.office365.com/owa/calendar/Booking-Soliciteunavisitamdicavirtualhoy@novonordisk.onmicrosoft.com/bookings/"
            target='_blank'
            className="block nav-link py-2 pl-3 pr-4 md:p-0 text-dark-purple-200 no-underline hover:text-pink-500"
          >
            Solicite una visita
          </Navbar.Link> */}

          <button
            id="dropdownRightButton"
            onClick={handleDropdownToggle}
            className="flex items-center px-4 py-2 bg-btn-user text-white rounded-lg"
          >
            <span className="mr-2 block whitespace-pre-wrap text-xs">
              {formatSpeakerName(`${name}`)}
              <br />
              <span className='ApisBold'>{lastName}</span>
            </span>
            <div className="flex items-center justify-center w-8 h-8 bg-white rounded-full">
              <img src="/images/icons/Profile.png" className="w-4 h-[1.5rem] object-contain" alt="profile" />
            </div>
          </button>

          {isDropdownOpen && (
            <div
              id="dropdownRight"
              className="bg-violet-100 absolute z-10 mt-2 bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-700 right-10 top-20 md:top-30"
            >
              <div className="flex flex-col items-center p-4">
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center">
                  <img src="/images/icons/Profile.png" className="w-12 h-18" alt="profile" />
                </div>
                <div className="mt-2 text-center">
                  <p className="text-lg ApisRegular text-dark-purple-800">¡Hola, Dr. {name} {lastName}!</p>
                </div>
                <div className="py-1">
                  {source == 'POEP' ?
                    null
                    :
                    // <Link
                    //   to="/certificados"
                    //   onClick={() => { handleLinkClick(); logsUserService(idUser, "Clic en Certificados", token) }}
                    //   className="flex items-center px-4 py-2 w-80 p-4 mt-2 mb-3 text-dark-purple-800 fs-6 text-center bg-white rounded-md hover:bg-gray-100 hover:text-purple-700"
                    // >
                    //   <img src="/images/icons/Certificado.png" className="w-8 h-8 mr-2" alt="certificados" />
                    //   Certificados
                    // </Link>
                    <></>
                  }
                  <Link
                    onClick={async () => {
                      await logsUserService(idUser, `Cerrando sesión`, token);
                      logoutObesity()
                    }}
                    className="flex items-center px-4 py-2 w-80 p-4 text-dark-purple-800 fs-6 bg-white rounded-md hover:bg-gray-100 hover:text-purple-700"
                  >
                    <img src="/images/icons/Logout.png" className="w-8 h-8 mr-2" alt="logout" />
                    Cerrar sesión
                  </Link>
                </div>
              </div>
            </div>
          )}
        </Navbar.Collapse>
      </Navbar>

      <Drawer open={isOpen} onClose={handleClose}>
        <Drawer.Header title="MENU" titleIcon={() => <></>} />
        <Drawer.Items>
          <Sidebar
            aria-label="Sidebar with multi-level dropdown example"
            className="[&>div]:bg-transparent [&>div]:p-0 px-0"
          >
            <img
              src="/images/icons/nav-logo.png"
              width="140"
              height="80"
              className="d-inline-block align-text-top text-center p-2 ml-2"
              alt="Logo"
            />
            <div className="flex h-full flex-col justify-between px-0">
              <div className="px-0">
                <Sidebar.Items>
                  <Sidebar.ItemGroup>
                    {/* <Link
                      to="/inicio"
                      onClick={() => { handleLinkClick(); logsUserService(idUser, "Clic en Inicio", token) }}
                      className={`nav-link text-dark-purple-200 ApisBold text-items-nav ${isActive('/inicio')}`}
                      style={{ color: 'inherit' }}
                    >
                      <Sidebar.Item className="text-dark-purple-200 ApisBold no-underline" href="/">
                        <HiHome className={`mr-1 inline ico ${isActive('/inicio') ? 'ico-active' : 'ico-normal'}`} />
                        <span className='ApisBold'>Inicio</span>
                      </Sidebar.Item>
                    </Link> */}
                    {/* <Link
                      to="/eventos"
                      onClick={() => { handleLinkClick(); logsUserService(idUser, "Clic en Eventos", token) }}
                      className={`nav-link text-dark-purple-200 ApisBold text-items-nav ${isActive('/eventos')}`}
                      style={{ color: 'inherit' }}
                    >
                      <Sidebar.Item className="text-dark-purple-200 ApisBold no-underline" href="/e-commerce/products">
                        <FaCalendarCheck className={`mr-1 inline ico ${isActive('/eventos') ? 'ico-active' : 'ico-normal'}`} />
                        <span className='ApisBold'>Eventos</span>
                      </Sidebar.Item>
                    </Link> */}
                    <Link
                      to="/e-learning-hub"
                      onClick={() => { handleLinkClick(); logsUserService(idUser, "Clic en E-Learning Hub", token) }}
                      className={`nav-link text-dark-purple-200 ApisBold text-items-nav ${isActive('/e-learning-hub')}`}
                      style={{ color: 'inherit' }}
                    >
                      <Sidebar.Item className="text-dark-purple-200 ApisBold no-underline" href="/e-commerce/products">
                        <RiGraduationCapFill className={`mr-1 inline ico ${isActive('/e-learning-hub') ? 'ico-active' : 'ico-normal'}`} />
                        <span className='ApisBold'>E-Learning Hub</span>
                      </Sidebar.Item>
                    </Link>
                    {/* <Sidebar.Item className="text-dark-purple-200 ApisBold no-underline" href="https://www.onenovonordisk.com/obesidad/podcast-mas-alla-del-peso.html"
                      target='_blank'
                    >
                      <HiMicrophone className={`mr-1 inline ico-normal`} />
                      <span className='ApisBold'>Podcast</span>
                    </Sidebar.Item> */}
                  </Sidebar.ItemGroup>
                  <Sidebar.ItemGroup className="mt-auto">
                    {/* Additional sidebar items can be added here */}
                  </Sidebar.ItemGroup>
                </Sidebar.Items>
              </div>
            </div>
          </Sidebar>
        </Drawer.Items>
        <div
          onClick={toggleDropdownMobile}
          aria-controls="navbar-dropdown"
          aria-expanded={isOpen}
          className="p-3 bg-btn-user text-white rounded-lg shadow-sm flex items-center space-x-3"
        >
          <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
            <img src="/images/icons/Profile.png" className="w-6 h-6" alt="profile" />
          </div>
          <div className="flex-1">
            <h4 className="text-sm font-medium mt-2">{formatSpeakerName(`${name} ${lastName}`)}</h4>
          </div>
        </div>

        {isDropMobilOpen && (
          <div
            id="navbar-dropdown"
            className="absolute bg-violet-100 text-black shadow-lg rounded-lg mt-2 w-64 mx-2"
          >
            <div className="py-1 mt-2 mb-3 scale-80">
              {/* <Link
                to="/certificados"
                onClick={() => { handleLinkClick(); logsUserService(idUser, "Clic en Certificados", token) }}
                className="flex items-center px-4 py-2 w-76 p-4 mt-2 mb-3 text-dark-purple-800 fs-6 text-center bg-white rounded-md hover:bg-gray-100 hover:text-purple-700"
              >
                <img src="/images/icons/Certificado.png" className="w-8 h-8 mr-2" alt="certificados" />
                Certificados
              </Link> */}
              <Link
                onClick={async () => {
                  await logsUserService(idUser, `Cerrando sesión`, token);
                  logoutObesity()
                }}
                className="flex items-center px-4 py-2 w-76 p-4 text-dark-purple-800 fs-6 bg-white rounded-md hover:bg-gray-100 hover:text-purple-700"
              >
                <img src="/images/icons/Logout.png" className="w-8 h-8 mr-2" alt="logout" />
                Cerrar sesión
              </Link>
            </div>
          </div>
        )}
      </Drawer>
    </>
  );
};

export default HeaderComponent;
